import '../App.css';
import { useNavigate } from 'react-router-dom';
import CustomButton from '../components/CustomButton';

export default function Dashboard() {

    const navigate = useNavigate();

    const next= () => {
        navigate('/intro')
    }

    return (
        <div className='story flex flex-col justify-around' style={{ backgroundImage: "url(/main-bg.png)"}}>

            <img src="/cpf-logo.jpg" className="self-center" width="125" height="125"/>

            <img src="/game-logo.png" className="self-center mx-4 " width="325" height="auto" />

            <div className="bg-white p-2 text-center text-2xl font-semibold rounded-lg outline outline-offset-2 outline-cyan-500 mx-6">A game about CPF's<br/>e-Services.</div>

            <div className="text-center font-bold py-6 ">
                <CustomButton text="Start" onClick={next}/>
            </div>

        </div>
        
    );
}